import React, { useEffect, useState } from "react";
import { Card, CardContent } from "../../../../components/ui/Card";
import DataTableColumnHeader from "../../../../components/table-components/data-table-column-header";
import { useDispatch, useSelector } from "react-redux";
import { countryAction } from "../../../../store/actions/countryAction";
import { ycrAction } from "../../../../store/actions/admin/ycrAction";
import { ycrAssetAction } from "../../../../store/actions/user/ycrAssetAction";
import { Filters } from "../../../../constant";
import { Label } from "../../../../components/ui/label";
import { DatePickerCustomInput } from "../../../../components/ui/DatePickerCustomInput";
import { Checkbox } from "../../../../components/ui/checkbox";
import Select, { components } from "react-select";
import { Button } from "../../../../components/ui/button";
import { DataTableWithCustomPagination } from "@/shared/DataTableWithCustomPagination";
import ScatterChartData from "./charts/ScatterChart";
import { Select as ShadCnSelect, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { assetValueAction } from "../../../../store/actions/user/assetValueAction";
import LineChartData from "./charts/LineChart2";
import countriesAccept from "../../../../shared";
import WholeCurveTimeSeriesChart from "./charts/WholeCurveTimeSeriesChart";
import Loading from "../../../../components/common/Loading";
import CountryCommon from "../../../../components/common/CountryCommon";

const CurvesContent = () => {
  const { countries, ycrData, ycrAssetData, assetValueData, isLoading } =
    useSelector((state) => state);
  const [dataLoad, setDataLoad] = useState(false)
  const dispatch = useDispatch();
  const [isShowTable, setIsShowTable] = useState(false);
  const [isShowChart, setIsShowChart] = useState(false);
  const [applyDateType, setApplyDateType] = useState(false);
  const [isShowCurveSeriesChart, setIsShowCurveSeriesChart] = useState(false);
  const [isShowWholeCurveSeriesChart, setIsShowWholeCurveSeriesChart] =
    useState(false);
  const [selectedAssetValueNames, setSelectedAssetValueNames] = useState([]);
  const [withoutWholeTimeSeriesChartData, setWithoutWholeTimeSeriesChartData] =
    useState([]);
  const [actualPrepareAssetValueData, setActualPrepareAssetValueData] =
    useState([]);

  const [tenorName, setTenorName] = useState([])

  // pagination
  const [currentPage, setCurrentPage] = useState(Filters.PAGE);
  const [perPage, setPerPage] = useState(Filters.OBJ.perPage); // Default per page e
  const [totalRecords, setTotalRecords] = useState(Filters.OBJ.totalRecords);
  const [totalPages, setTotalPages] = useState(Filters.OBJ.totalPages);
  const [firstTime, setFirstTime] = useState(true);
  const [groupedDataCurve, setGroupedDataCurve] = useState({});
  const [groupedDataTenure, setGroupedDataTenure] = useState({});

  const [tableData, setTableData] = useState([]);
  const [tableColumns, setTableCOlumns] = useState([]);
  const [errors, setErrors] = useState({});
  const [selectDateTypeForCurveTimeSeries, setSelectDateTypeForCurveTimeSeries] = useState({
    label: "Month",
    value: "month"
  });
  const [selectDateTypeForWholeCurveTimeSeries, setSelectDateTypeForWholeCurveTimeSeries] = useState({
    label: "Month",
    value: "month"
  })

  const [formData, setFormData] = useState({
    countriesId: [],
    interestRateDataTypeId: [],
    startDate: null,
    endDate: null,
    assetIds: [],
    table: false,
    timeSeriesChart: false,
    curveSeriesChart: false,
    wholeCurveTimeSeriesChart: false,
  });

  useEffect(() => {
    dispatch(countryAction());
  }, []);

  useEffect(() => {
    if (formData?.countriesId?.length >= 1) {
      dispatch(
        ycrAction({
          countryIds: formData?.countriesId,
        })
      );
    }
  }, [formData?.countriesId]);

  useEffect(() => {
    setFormData({
      ...formData,
      assetIds: [],
    });
  }, [formData.interestRateDataTypeId]);

  useEffect(() => {
    if (
      formData.countriesId?.length >= 1 &&
      formData.interestRateDataTypeId?.length >= 1
    ) {
      const filter = {
        countryIds: formData.countriesId,
        interestRateDataTypeIds: formData.interestRateDataTypeId,
      };
      dispatch(ycrAssetAction(filter));
    }
  }, [formData.countriesId, formData.interestRateDataTypeId]);

  useEffect(() => {
    // let prePareData = null;
    // const allAssetIds =
    //   assetValueData?.assets?.length > 0 &&
    //   assetValueData?.assets?.map((asset) => asset?._id);
    const actualAssetsData =
      assetValueData?.records?.length > 0 &&
      assetValueData?.records?.map((items) => {

        const getAsset =
          assetValueData?.assets?.length > 0 &&
          assetValueData?.assets?.find((item) => item?._id === items?.asset);
        const { asset, ...rest } = items;

        return { asset: getAsset, ...rest };
      });

    if (actualAssetsData?.length > 0) {
      setActualPrepareAssetValueData(actualAssetsData);
    }
    // 

    const generateHeaders = (data) => {
      const headers = new Set();
      //
      data && data.forEach((item) => {
        // Extracting headers from the 'asset' object
        const asset = item.asset;
        if (asset) {
          if (asset.slug) {
            headers.add(
              `${item?.asset?.country?.alpha2Code}-${item?.asset?.maturity}-${item?.asset?.interestRateDataType?.type}`
            );
          }
        }

        // Adding 'Date' header
        if (item.date) {
          headers.add("Date");
        }
      });

      return Array.from(headers);
    };

    const generatedHeaders = generateHeaders(actualAssetsData);
    // ;
    // let headers;
    // actualAssetsData && actualAssetsData?.length ? actualAssetsData?.map(item => {
    //     // 
    //     const { date, ...rest } = item; // Destructure and rename
    //     const slugKey = `${item?.asset?.country?.alpha2Code}-${item?.asset?.slug}-${item?.asset?.interestRateDataType?.type}`
    //     const newItem = { Date: "date", slugKey };
    //     headers = newItem && [...new Set(Object?.values(newItem.Date === "date" ? "Date" : newItem))]
    // }) : {};

    const filteredHeaders = actualAssetsData?.length > 0 && actualAssetsData.filter((header) => {
      header !== "Date" && formData?.assetIds?.includes(header?.asset?._id);
    });

    const data = actualAssetsData?.length > 0 && actualAssetsData;
    setTableCOlumns(filteredHeaders);
    setTableData((prev) => {
      return (prev = data);
    });
    // setTotalRecords(actualAssetsData?.length && data?.length);
    // setTotalPages(
    //   Math.ceil(actualAssetsData?.length && data?.length / perPage)
    // );

    if (formData?.assetIds?.length > 0 && data?.length > 0) {
      const selectedAssetValueRecords =
        ycrAssetData.records?.length > 0 &&
        ycrAssetData.records?.filter((ycrAsset) =>
          formData?.assetIds?.includes(ycrAsset?._id)
        );
      const selectedAssetValueRecordsNames =
        selectedAssetValueRecords?.length > 0 &&
        selectedAssetValueRecords?.map((record) => {
          return `${record?.country?.alpha2Code}-${record?.maturity}-${record?.interestRateDataType?.type}`;
        });
      setSelectedAssetValueNames(selectedAssetValueRecordsNames);

      const transformData = (data) => {
        const result = {};

        data.forEach((item) => {
          const country = item?.asset?.country?.alpha2Code || "";
          const maturity = item?.asset?.maturity || "";
          const type = item?.asset?.interestRateDataType?.type || "";
          const value = item?.value || "";
          const date = new Date(item.date).toLocaleDateString("en-GB") || "";

          // Constructing the key as 'CountryCode-Slug-Type'
          const key = `${country}-${maturity}-${type}`;

          // Check if the date is already in the result
          if (!result[date]) {
            result[date] = { date: date };
          }

          // Add the key-value pair to the corresponding date object
          result[date][key] = value;
        });

        // Convert the result object to an array of objects
        return Object.values(result);
      };

      // Example usage
      const transformedData = transformData(actualAssetsData);
      setWithoutWholeTimeSeriesChartData(transformedData);

      //   const data = actualAssetsData?.length > 0 && actualAssetsData;
      //   setTableCOlumns(filteredHeaders);
      //   setTableData((prev) => {
      //     return (prev = data);
      //   });
      setTotalRecords(transformedData?.length && transformedData?.length);
      setTotalPages(
        Math.ceil(transformedData?.length && transformedData?.length / perPage)
      );
    }
  }, [assetValueData]);

  const startIndex = (currentPage - 1) * perPage;
  const endIndex = Math.min(startIndex + perPage, tableData?.length);

  const paginatedData =
    (withoutWholeTimeSeriesChartData?.length >= 1 &&
      withoutWholeTimeSeriesChartData?.slice(startIndex, endIndex)) ||
    [];
  const columns = selectedAssetValueNames?.length
    ? ["Date", ...selectedAssetValueNames.sort((a, b) => {
      const getTimeValue = (str) => {
        let [, value, unit] = str.split(/[ -]/);
        value = parseInt(value);
        return unit === "Yr" ? value * 12 : value;
      };

      return getTimeValue(a) - getTimeValue(b);
    })]?.map((header) => {
      return {
        accessorKey: header === "Date" ? "date" : header,
        header: ({ column }) => (
          <DataTableColumnHeader column={column} title={header} />
        ),
        cell: ({ row }) => (
          <span className="flex items-center">
            {row?.original?.[header === "Date" ? "date" : header] ?? "-"}
          </span>
        ),
        enableSorting: true,
      };
    })
    : [];

  useEffect(() => {
    setFirstTime(false);
  }, []);

  useEffect(() => {
    !firstTime && Object.keys(errors).length > 0 && handleValidation();
  }, [formData]);

  const countryOptions =
    countries && countries?.length
      ? countries
        ?.sort((a, b) => a.countryName.localeCompare(b.countryName))
        ?.filter((item) => countriesAccept.includes(item.countryName))
        ?.map((item) => {
          return { label: item.countryName, value: item._id };
        })
      : [];

  const InterestRateDataTypeOptions =
    ycrData?.records?.length > 0
      ? (ycrData.records || []).map((item) => ({
        label: item.type,
        value: item._id,
      }))
      : [];

  const assetOptions =
    ycrAssetData?.records?.length > 0
      ? [
        {
          label: "All",
          value: "all",
          fullName: 'All'
        },
        ...ycrAssetData.records.map((item) => ({
          label: item.slug,
          value: item._id,
          fullName: `${item.country.alpha2Code}-${item.maturity}-${item.interestRateDataType.type}`
        })),
      ]
      : [];

  const onCheckedCountryOptions = (props) => {
    const { data } = props;
    if (data.value === "all") {
      if (formData.countriesId?.length === countryOptions?.length) {
        setFormData({ ...formData, countriesId: [] });
      } else {
        setFormData({
          ...formData,
          countriesId: countryOptions.map((option) => option.value),
        });
      }
    } else {
      setFormData((prev) => {
        let newData;
        const alreadyExists = prev.countriesId.some(
          (item) => item === data.value
        );
        if (alreadyExists) {
          const alreadyExistsData = prev.countriesId.filter(
            (item) => item !== data.value
          );
          newData = alreadyExistsData;
        } else {
          newData =
            countryOptions?.value !== null
              ? [...prev.countriesId, data?.value]
              : [data?.value];
        }
        return {
          ...prev,
          countriesId: newData?.filter((aed) => aed !== "all"),
        };
      });
    }
  };

  const onCheckedInterestRateDataOptions = (props) => {
    const { data } = props;
    if (data.value === "all") {
      if (
        formData.interestRateDataTypeId?.length ===
        InterestRateDataTypeOptions?.length
      ) {
        setFormData({ ...formData, interestRateDataTypeId: [] });
      } else {
        setFormData({
          ...formData,
          interestRateDataTypeId: InterestRateDataTypeOptions.map(
            (option) => option.value
          ),
        });
      }
    } else {
      setFormData((prev) => {
        let newData;
        const alreadyExists = prev.interestRateDataTypeId.some(
          (item) => item === data.value
        );
        if (alreadyExists) {
          const alreadyExistsData = prev.interestRateDataTypeId.filter(
            (item) => item !== data.value
          );
          newData = alreadyExistsData;
        } else {
          newData =
            InterestRateDataTypeOptions?.value !== null
              ? [...prev.interestRateDataTypeId, data?.value]
              : [data?.value];
        }
        return {
          ...prev,
          interestRateDataTypeId: newData?.filter((aed) => aed !== "all"),
        };
      });
    }
  };

  const onCheckedAssetDataOptions = (props) => {
    const { data } = props;
    if (data.value === "all") {
      if (formData.assetIds?.length === assetOptions?.length) {
        setFormData({ ...formData, assetIds: [] });
        setTenorName([])
      } else {
        setFormData({
          ...formData,
          assetIds: assetOptions.map((option) => option.value),
        });
        setTenorName(assetOptions.map((option) => option.fullName))
      }
    } else {
      setTenorName((prev) => {
        let newData;
        const alreadyExists = prev.some((item) => item === data.fullName);
        if (alreadyExists) {
          const alreadyExistsData = prev.filter(
            (item) => item !== data.fullName
          );
          newData = alreadyExistsData;
        } else {
          newData =
            assetOptions?.value !== null
              ? [...prev, data?.fullName]
              : [data?.fullName];
        }
        return newData?.filter((aed) => aed !== "all");
      })
      setFormData((prev) => {
        let newData;
        const alreadyExists = prev.assetIds.some((item) => item === data.value);
        if (alreadyExists) {
          const alreadyExistsData = prev.assetIds.filter(
            (item) => item !== data.value
          );
          newData = alreadyExistsData;
        } else {
          newData =
            assetOptions?.value !== null
              ? [...prev.assetIds, data?.value]
              : [data?.value];
        }
        return { ...prev, assetIds: newData?.filter((aed) => aed !== "all") };
      });
    }
  };

  const OptionCountryOptions = ({ children, ...props }) => {
    const { onCheckedOptions } = props.selectProps;
    return (
      <components.Control {...props}>
        <div
          className="flex p-2 align-middle justify-start items-center text-sm w-full"
          onClick={() => onCheckedOptions(props)}
        >
          <span className="me-2">
            <Checkbox
              checked={formData.countriesId.includes(props.data.value)}
              aria-label="Select row"
              className="translate-y-[2px] border-black rounded-[4px]"
            />
          </span>
          {children}
        </div>
      </components.Control>
    );
  };

  // for curve group data

  useEffect(() => {
    const groupedData2 =
      ycrData?.records?.length > 0 &&
      ycrData?.records.reduce((acc, curr) => {
        const countryName = curr.country.countryName;
        acc[countryName] = acc[countryName] || [];
        acc[countryName].push(curr);
        return acc;
      }, {});
    setGroupedDataCurve(groupedData2);
  }, [ycrData?.records]);

  const transformedDataCurve = Object.entries(groupedDataCurve).map(
    ([countryName, countryData]) => ({
      label: countryName,
      options: countryData.map((item) => ({
        label: item.type,
        value: item?._id,
      })),
    })
  );

  // for tenure group data
  useEffect(() => {

    const groupedData2 = {};
    if (ycrAssetData?.records?.length > 0) {
      groupedData2.all = [{ label: "All", value: "all", fullName: 'All' }]; // Add "all" option

      for (const record of ycrAssetData.records) {
        const countryName = record.country?.countryName || "Unknown"; // Check and set default for missing countryName
        groupedData2[countryName] = groupedData2[countryName] || []; // Initialize empty array if not already present
        groupedData2[countryName]?.push({
          label: countryName,
          value: record._id,
          fullName: `${record.country.alpha2Code}-${record.maturity}-${record.interestRateDataType.type}`
        }); // Push record data
      }
    }

    setGroupedDataTenure(groupedData2);
  }, [ycrAssetData?.records]);

  const transformedDataTenure = Object.entries(groupedDataTenure).map(
    ([countryName, countryData]) => {
      return {
        label: countryName,
        options: countryData.map((item) => ({
          label: item.label,
          value: item?.value,
          fullName: item?.fullName
        })),
      };
    }
  );

  // show all and other labels of group

  const formatGroupLabel = (group) => {
    return (
      <div className="text-[12px] pt-1 pb-2 font-bold tracking-widest">
        {group?.label}
      </div>
    );
  };

  const InterestRateDataOptions = ({ children, ...props }) => {
    const { onCheckedCountryOptions } = props.selectProps;
    return (
      <>
        <components.Control {...props}>
          <div
            className="flex p-2 align-middle justify-start items-center text-sm w-full"
            onClick={() => onCheckedCountryOptions(props)}
          >
            <span className="me-2">
              <Checkbox
                checked={formData.interestRateDataTypeId.includes(
                  props.data.value
                )}
                aria-label="Select row"
                className="translate-y-[2px] border-black rounded-[4px]"
              />
            </span>
            {children}
          </div>
        </components.Control>
      </>
    );
  };

  const AssetDataOptions = ({ children, ...props }) => {
    const { onCheckedOptions } = props.selectProps;
    return (
      <components.Control {...props}>
        <div
          className="flex p-2 align-middle justify-start items-center text-sm w-full"
          onClick={() => onCheckedOptions({ ...props })}
        >
          <span className="me-2">
            <Checkbox
              checked={formData.assetIds.includes(props.data.value)}
              aria-label="Select row"
              className="translate-y-[2px] border-black rounded-[4px]"
            />
          </span>
          {props.data.fullName}
        </div>
      </components.Control>
    );
  };

  const handleValidation = () => {
    let valid = true;
    let error = {};
    if (formData.countriesId?.length === 0) {
      error.countriesId = "please select any Countries";
      valid = false;
    }

    if (formData.interestRateDataTypeId?.length === 0) {
      error.interestRateDataTypeId = "please select any interest Rate DataType";
      valid = false;
    }
    if (formData.startDate === null) {
      error.startDate = "please select Start date";
      valid = false;
    }
    if (formData.endDate === null) {
      error.endDate = "please select endDate";
      valid = false;
    }
    if (
      (formData.assetIds === null || formData.assetIds?.length === 0) &&
      !formData?.wholeCurveTimeSeriesChart
    ) {
      error.assetIds = "please select Tenor";
      valid = false;
    }
    if (
      formData.table === false &&
      formData.timeSeriesChart === false &&
      formData.curveSeriesChart === false &&
      formData.wholeCurveTimeSeriesChart === false
    ) {
      error.display = "please select display";
      valid = false;
    }

    setErrors(error);
    return valid;
  };

  const onSave = () => {
    if (handleValidation()) {
      setDataLoad(true)
      const allTenure =
        assetOptions?.length > 0 &&
        assetOptions?.filter((option) => option?.value !== "all");
      const allTenureIds =
        allTenure?.length > 0 && allTenure?.map((tenure) => tenure?.value);
      const filter = {
        startDate: formData.startDate,
        endDate: formData.endDate,
        assetIds: !formData?.wholeCurveTimeSeriesChart
          ? formData.assetIds.filter((item) => item !== "all")
          : allTenureIds,
        type: "chart",
      };

      if (formData?.assetIds?.length > 0 && tableData?.length > 0) {
        const selectedAssetValueRecords =
          ycrAssetData.records?.length > 0 &&
          ycrAssetData.records?.filter((ycrAsset) =>
            formData?.assetIds?.includes(ycrAsset?._id)
          );
        const selectedAssetValueRecordsNames =
          selectedAssetValueRecords?.length > 0 &&
          selectedAssetValueRecords?.map((record) => {
            return `${record?.country?.alpha2Code}-${record?.slug}-${record?.interestRateDataType?.type}`;
          });
        setSelectedAssetValueNames(selectedAssetValueRecordsNames);

        function filterObjectsByKeys(dataArray, keyArray) {
          const filteredDataArray = [];

          for (const dataObject of dataArray) {
            const filteredObject = {};
            for (const key in dataObject) {
              if (keyArray.includes(key) || key === "date") {
                filteredObject[key] = dataObject[key];
              }
            }

            if (Object.keys(filteredObject).length > 0) {
              // Check if any matches found
              filteredDataArray.push(filteredObject);
            }
          }

          return filteredDataArray;
        }
        let data = filterObjectsByKeys(tableData, selectedAssetValueRecordsNames)
        // setWithoutWholeTimeSeriesChartData(
        //   filterObjectsByKeys(tableData, selectedAssetValueRecordsNames)
        // );
      }
      setCurrentPage(1);
      setIsShowTable(formData.table);
      setIsShowChart(formData.timeSeriesChart);
      setIsShowCurveSeriesChart(formData.curveSeriesChart);
      setIsShowWholeCurveSeriesChart(formData.wholeCurveTimeSeriesChart);
      dispatch(assetValueAction(filter, setDataLoad));
    }
  };

  const showNamesOfCountries = () => {
    let names = "";
    countryOptions?.length > 0 &&
      countryOptions?.map((country) => {
        if (formData?.countriesId?.includes(country?.value)) {
          names += country?.label + ", ";
        }
      });
    return names;
  };

  const showPlaceholder = () => {
    let filterName = "";
    if (formData.assetIds.length > 0) {
      const filterRecords = formData.assetIds.filter((rec) => rec !== "all");
      filterName = filterRecords
        .map((assetMapId) => {
          const id = assetMapId;
          const placeholderName =
            id !== "all" &&
            ycrAssetData?.records?.length > 0 &&
            ycrAssetData?.records?.filter((record) => record?._id === id);
          return (
            id !== "all" &&
            `${placeholderName[0]?.country?.alpha2Code} - ${placeholderName[0]?.maturity} - ${placeholderName[0]?.interestRateDataType?.type}`
          );
        })
        .join(", ");
    } else {
      filterName = "Select Tenor";
    }
    return filterName;
  };


  const onChangeDateWiseChart = (event) => {
    setSelectDateTypeForCurveTimeSeries(event)
  }

  const onChangeDateWiseChartForWholeCurveTimeSeries = (event) => {
    setSelectDateTypeForWholeCurveTimeSeries(event)
  }
  const DateWiseChartOptions = [
    { label: 'Month', value: 'month' },
    { label: 'Year', value: 'year' }
  ];




  return (
    <div className="p-5">
      {/* dataLoad */}
      {/* <Card className={`bg-white p-4 ${dataLoad ? 'h-[480px]' : ''}`}>
        <CardContent className={`p-2 ${dataLoad ? 'h-[480px]' : ''}`}>
         {dataLoad ? <div className="h-full flex flex-col justify-center">
          <Loading />
         </div> : */}
      <Card className={`bg-white p-4 `}>
        <CardContent className={`p-2 `}>
          {
            <div className="grid grid-cols-1 items-center gap-1">
              {/* <div className="form-group grid grid-cols-12 items-center gap-1">
                <div className="lable-wrapper  col-span-12">
                  <Label
                    htmlFor="name"
                    className="text-[13px] text-textV2 font-500 cursor-pointer"
                  >
                    Country:<span style={{ color: "red" }}>*</span>
                  </Label>
                </div>
                <div className="field-wrapper col-span-12">
                  <Select
                    components={{ Option: OptionCountryOptions }}
                    isSearchable={false}
                    inputValue=""
                    value={null}
                    closeMenuOnSelect={false}
                    onCheckedOptions={onCheckedCountryOptions}
                    placeholder={
                      formData.countriesId?.length > 0
                        ? showNamesOfCountries()
                        : "Country"
                    }
                    name="Country"
                    className="multi_react_select curves_selectors"
                    options={countryOptions}
                    styles={{
                      menuList: (base) => ({
                        ...base,
                        fontSize: "10px",
                        overflow: "auto",
                        maxHeight: "500px",
                        lineHeight: "1rem",
                        fontWeight: 500,
                        borderRadius: "0",
                        backgroundColor: "transparent",
                      }),
                      menu: (base) => ({
                        ...base,
                        overflow: "auto",
                        margin: 0,
                        padding: 0,
                        width: "100%",
                        borderRadius: "0",
                      }),
                      input: (base) => ({
                        ...base,
                        width: "100%",
                      }),
                      container: (base) => ({
                        ...base,
                        width: "100%",
                      }),
                    }}
                  />
                </div>
              </div> */}
              <CountryCommon countries={countries || []} formData={formData} setFormData={setFormData} countriesAccept={countriesAccept} selectedValues={formData?.countriesId} />
              <div
                className={errors["countriesId"] ? "text-red text-[10px]" : ""}
              >
                {errors["countriesId"] ? errors["countriesId"] : null}
              </div>
              <div className="form-group grid grid-cols-12 items-center gap-1">
                <div className="lable-wrapper  col-span-12">
                  <Label
                    htmlFor="name"
                    className="text-[13px] text-textV2 font-500 cursor-pointer"
                  >
                    Curve:<span style={{ color: "red" }}>*</span>
                  </Label>
                </div>
                <div className="field-wrapper col-span-12">
                  <Select
                    components={{ Option: InterestRateDataOptions }}
                    formatGroupLabel={formatGroupLabel}
                    isSearchable={false}
                    isDisabled={formData?.countriesId.length === 0}
                    inputValue=""
                    value={null}
                    closeMenuOnSelect={false}
                    onCheckedCountryOptions={onCheckedInterestRateDataOptions}
                    placeholder={
                      formData.interestRateDataTypeId.length
                        ? InterestRateDataTypeOptions.filter((item) =>
                          formData.interestRateDataTypeId.includes(item.value)
                        )
                          ?.map((item) => item.label)
                          .join(", ")
                        : "Select Curves"
                    }
                    name="Curves"
                    className="multi_react_select curves_selectors"
                    options={transformedDataCurve}
                    styles={{
                      menuList: (base) => ({
                        ...base,
                        fontSize: "10px",
                        overflow: "auto",
                        maxHeight: "500px",
                        lineHeight: "1rem",
                        fontWeight: 500,
                        borderRadius: "0",
                        backgroundColor: "transparent",
                      }),
                      menu: (base) => ({
                        ...base,
                        overflow: "auto",
                        margin: 0,
                        padding: 0,
                        width: "100%",
                        borderRadius: "0",
                      }),
                      input: (base) => ({
                        ...base,
                        width: "100%",
                        "::placeholder": {
                          color: "black",
                        },
                      }),
                      container: (base) => ({
                        ...base,
                        width: "100%",
                      }),
                      placeholder: (base) => ({
                        ...base,
                        fontSize: "50px",
                        color: "black",
                        fontWeight: "bold",
                      }),
                    }}
                  />
                </div>
              </div>
              <div
                className={
                  errors["interestRateDataTypeId"] ? "text-red text-[10px]" : ""
                }
              >
                {errors["interestRateDataTypeId"]
                  ? errors["interestRateDataTypeId"]
                  : null}
              </div>

              <div className="form-group grid grid-cols-12 items-center gap-1">
                <div className="lable-wrapper col-span-4lable-wrapper col-span-12">
                  <Label
                    htmlFor="asset"
                    className="text-[13px] text-textV2 font-500 cursor-pointer"
                  >
                    Tenor:{" "}
                    {formData.wholeCurveTimeSeriesChart === false && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                  </Label>
                </div>
                <div className="field-wrapper col-span-12 ">
                  <Select
                    isSearchable={false}
                    isDisabled={
                      formData.countriesId?.length === 0 ||
                      formData.interestRateDataTypeId?.length === 0
                    }
                    inputValue=""
                    components={{ Option: AssetDataOptions }}
                    formatGroupLabel={formatGroupLabel}
                    value={null}
                    closeMenuOnSelect={false}
                    onCheckedOptions={onCheckedAssetDataOptions}
                    placeholder={showPlaceholder()}
                    options={transformedDataTenure}
                    name="Interest Rate Type"
                    className="multi_react_select curves_selectors"
                    styles={{
                      menuList: (base) => ({
                        ...base,
                        fontSize: "10px",
                        overflow: "auto",
                        maxHeight: "600px",
                        lineHeight: "1rem",
                        fontWeight: 500,
                        borderRadius: "0",
                        backgroundColor: "transparent",
                      }),
                      menu: (base) => ({
                        ...base,
                        overflow: "auto",
                        margin: 0,
                        padding: 0,
                        width: "100%",
                        borderRadius: "0",
                      }),
                      input: (base) => ({
                        ...base,
                        width: "100%",
                      }),
                      container: (base) => ({
                        ...base,
                        width: "100%",
                      }),
                    }}
                  />
                </div>
              </div>
              <div className={errors["assetIds"] ? "text-red text-[10px]" : ""}>
                {errors["assetIds"] ? errors["assetIds"] : null}
              </div>

              <div className="form-group grid grid-cols-2 items-center gap-1">
                <div className="form-group grid grid-cols-12 items-center gap-1">
                  <div className="lable-wrapper  col-span-12">
                    <Label
                      htmlFor="name"
                      className="text-[13px] text-textV2 font-500 cursor-pointer"
                    >
                      Start Date:<span style={{ color: "red" }}>*</span>
                    </Label>
                  </div>
                  <div className="field-wrapper col-span-12">
                    <DatePickerCustomInput
                      onDateSelect={(date) =>
                        setFormData({ ...formData, startDate: date })
                      }
                      placeholderText="YYYY-MM-DD"
                      selectedFromDate={formData.startDate}
                      mainClassName={"body-table"}
                      value={formData.startDate}
                    />
                  </div>
                  <div
                    className={
                      errors["startDate"]
                        ? "text-red text-[10px] col-span-12"
                        : ""
                    }
                  >
                    {errors["startDate"] ? errors["startDate"] : null}
                  </div>
                </div>
                <div className="form-group grid grid-cols-12 items-center gap-1">
                  <div className="lable-wrapper  col-span-12">
                    <Label
                      htmlFor="name"
                      className="text-[13px] text-textV2 font-500 cursor-pointer"
                    >
                      End Date:<span style={{ color: "red" }}>*</span>
                    </Label>
                  </div>
                  <div className="field-wrapper col-span-12">
                    <DatePickerCustomInput
                      onDateSelect={(date) =>
                        setFormData({ ...formData, endDate: date })
                      }
                      placeholderText="YYYY-MM-DD"
                      selectedFromDate={formData.endDate}
                      mainClassName={"body-table"}
                      value={formData.endDate}
                    />
                  </div>
                  <div
                    className={
                      errors["endDate"] ? "text-red text-[10px] col-span-12" : ""
                    }
                  >
                    {errors["endDate"] ? errors["endDate"] : null}
                  </div>
                </div>
              </div>

              <div className="form-group py-4 gap-1">
                <div className="form-group flex items-center gap-1 justify-start space-x-2">
                  <div className="mb-1">
                    <Label
                      htmlFor="name"
                      className="text-[13px] text-textV2 font-500 cursor-pointer"
                    >
                      Display:<span style={{ color: "red" }}>*</span>
                    </Label>
                  </div>
                  <div className="flex md:flex-nowrap flex-wrap col-span-11">
                    <div className="flex items-center space-x-2 me-3 lg:mb-[0] mb-[3px] ">
                      <Checkbox
                        id="Table"
                        className="border-black rounded-[4px]"
                        name="table"
                        checked={formData?.table}
                        onCheckedChange={(e) => {
                          if (formData?.wholeCurveTimeSeriesChart) {
                            setFormData({
                              ...formData,
                              table: e,
                            });
                          } else {
                            setFormData({
                              ...formData,
                              table: e,
                            });
                          }
                        }}
                      />
                      <Label
                        htmlFor="Table"
                        className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-nowrap"
                        style={{
                          fontSize: "0.75rem",
                          overflow: "auto",
                          maxHeight: "180px",
                          lineHeight: "1rem",
                          fontWeight: 500,
                          borderRadius: "5px",
                        }}
                      >
                        Rate Table
                      </Label>
                    </div>
                    <div className="flex items-center space-x-2  me-3 lg:mb-[0] mb-[3px] ">
                      <Checkbox
                        id="time-Series"
                        name="timeSeriesChart"
                        className=" border-black rounded-[4px]"
                        checked={formData?.timeSeriesChart}
                        onCheckedChange={(e) => {
                          if (formData?.wholeCurveTimeSeriesChart) {
                            setFormData({
                              ...formData,
                              timeSeriesChart: e,
                            });
                          } else {
                            setFormData({
                              ...formData,
                              timeSeriesChart: e,
                            });
                          }
                        }}
                      />
                      <Label
                        htmlFor="time-Series"
                        className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-nowrap"
                        style={{
                          fontSize: "0.75rem",
                          overflow: "auto",
                          maxHeight: "180px",
                          lineHeight: "1rem",
                          fontWeight: 500,
                          borderRadius: "5px",
                        }}
                      >
                        Rate Time Series Chart
                      </Label>
                    </div>
                    <div className="flex items-center space-x-2  me-3 lg:mb-[0] mb-[3px] ">
                      <Checkbox
                        id="curve-time-Series"
                        name="curveSeriesChart"
                        className=" border-black rounded-[4px]"
                        checked={formData?.curveSeriesChart}
                        onCheckedChange={(e) => {
                          if (formData?.wholeCurveTimeSeriesChart) {
                            setFormData({
                              ...formData,
                              curveSeriesChart: e,
                            });
                          } else {
                            setFormData({
                              ...formData,
                              curveSeriesChart: e,
                            });
                          }
                        }}
                      />
                      <Label
                        htmlFor="curve-time-Series"
                        className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-nowrap"
                        style={{
                          fontSize: "0.75rem",
                          overflow: "auto",
                          maxHeight: "180px",
                          lineHeight: "1rem",
                          fontWeight: 500,
                          borderRadius: "5px",
                        }}
                      >
                        Curve Time Series Chart
                      </Label>
                    </div>
                    <div className="flex items-center space-x-2  me-3 lg:mb-[0] mb-[3px] ">
                      <Checkbox
                        id="whole-curve-time-Series"
                        name="wholeCurveTimeSeriesChart"
                        className=" border-black rounded-[4px]"
                        checked={formData.wholeCurveTimeSeriesChart}
                        onCheckedChange={(e) => {
                          if (
                            formData?.curveSeriesChart ||
                            formData?.timeSeriesChart ||
                            formData?.table
                          ) {
                            setFormData({
                              ...formData,
                              wholeCurveTimeSeriesChart: e,
                            });
                          } else {
                            setFormData({
                              ...formData,
                              wholeCurveTimeSeriesChart: e,
                            });
                          }
                        }}
                      />
                      <Label
                        htmlFor="whole-curve-time-Series"
                        className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-nowrap"
                        style={{
                          fontSize: "0.75rem",
                          overflow: "auto",
                          maxHeight: "180px",
                          lineHeight: "1rem",
                          fontWeight: 500,
                          borderRadius: "5px",
                        }}
                      >
                        Whole Curve Time Series Chart
                      </Label>
                    </div>
                  </div>
                </div>
                <div className={errors["display"] ? "text-red text-[10px]" : ""}>
                  {errors["display"] ? errors["display"] : null}
                </div>
                <div className="form-group  pt-3 items-center gap-1">
                  <Button
                    className="py-2 px-6 text-[12px]"
                    onClick={() => onSave()}
                  >
                    Apply
                  </Button>
                </div>
              </div>
            </div>}
        </CardContent>
      </Card>
      {isShowTable ? (
        <Card className="bg-white p-4 my-3">
          <CardContent className="p-2">
            <h4 class="text-sm font-600 text-textV2">Rate Table:</h4>
            {dataLoad ? <Loading /> : <DataTableWithCustomPagination
              columns={columns}
              data={paginatedData}
              isSearchHide
              isCollViewHide={true}
              setCurrentPage={setCurrentPage}
              setPerPage={setPerPage}
              totalRecords={totalRecords}
              totalPages={totalPages}
              currentPage={currentPage}
              perPage={perPage}
              loadData={dataLoad}
            />}
          </CardContent>
        </Card>
      ) : (
        ""
      )}

      {isShowChart ? (
        <Card className="bg-white p-4 my-3">
          <CardContent className="p-2">
            <h4 class="text-sm font-600 text-textV2">
              Rate Time Series Chart:
            </h4>
            <ScatterChartData
              chartData={
                withoutWholeTimeSeriesChartData?.length > 0 &&
                withoutWholeTimeSeriesChartData
              }
              startDate={formData?.startDate}
              tenorName={tenorName}
              isLoading={dataLoad}
            />
          </CardContent>
        </Card>
      ) : (
        ""
      )}

      {isShowCurveSeriesChart ? (
        <Card className="bg-white p-4 my-3">
          <CardContent className="p-2">
            <div className="flex justify-start items-center px-2 gap-2">
              <h4 class="text-sm font-600 text-textV2">
                Curve Time Series Chart:
              </h4>
              <div className="flex justify-center items-center gap-2 px-2">
                <p className="px-2 w-full text-[13px] min-w-[140px]">X-axis Period Type</p>
                <ShadCnSelect

                  onValueChange={(e) => onChangeDateWiseChart(JSON.parse(e))}
                >
                  <SelectTrigger className="w-full h-[34px] min-w-[130px] text-[12px] rounded-5px] ">
                    <SelectValue
                      className='text-textV1 '
                      placeholder={selectDateTypeForCurveTimeSeries !== null ? selectDateTypeForCurveTimeSeries?.label : "XAxis Period Type"}
                    >
                      {selectDateTypeForCurveTimeSeries !== null ? selectDateTypeForCurveTimeSeries?.label : "XAxis Period Type"}
                    </SelectValue>
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      {
                        DateWiseChartOptions && DateWiseChartOptions.length > 0 ? DateWiseChartOptions.map((item, index) => {
                          return <SelectItem key={index} className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2" value={JSON.stringify(item)}>{item?.label}</SelectItem>
                        }) : <SelectItem disabled className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2 text-center" value={'No option'}>{'No option'}</SelectItem>
                      }
                    </SelectGroup>
                  </SelectContent>
                </ShadCnSelect>
                {/* <Button className="px-5 py-[7px]" onClick={handleApplyChartDateType}>Apply</Button> */}
              </div>
            </div>
            <LineChartData
              chartData={
                withoutWholeTimeSeriesChartData?.length > 0 &&
                withoutWholeTimeSeriesChartData
              }
              selectDateType={selectDateTypeForCurveTimeSeries} setSelectDateType={setSelectDateTypeForCurveTimeSeries}
              assetsValues={assetValueData}
              actualPrepareAssetValueData={actualPrepareAssetValueData}
              assetIds={formData.assetIds}
              // applyDateType={applyDateType} setApplyDateType={setApplyDateType}
              ycrAssetData={ycrAssetData}
              isLoading={dataLoad}
            />
          </CardContent>
        </Card>
      ) : (
        ""
      )}
      {isShowWholeCurveSeriesChart ? (
        <Card className="bg-white p-4 my-3">
          <CardContent className="p-2">
            <div className="flex justify-start items-center px-2 gap-2">
              <h4 class="text-sm font-600 text-textV2">
                Whole Curve Time Series Chart:
              </h4>
              <div className="flex justify-center items-center gap-2 px-2">
              <p className="px-2 w-full text-[13px] min-w-[140px]">X-axis Period Type</p>
                <ShadCnSelect

                  onValueChange={(e) => onChangeDateWiseChartForWholeCurveTimeSeries(JSON.parse(e))}
                >
                  <SelectTrigger className="w-full h-[34px] min-w-[130px] text-[12px] rounded-5px] ">
                    <SelectValue
                      className='text-textV1 '
                      placeholder={selectDateTypeForWholeCurveTimeSeries !== null ? selectDateTypeForWholeCurveTimeSeries?.label : "XAxis Period Type"}
                    >
                      {selectDateTypeForWholeCurveTimeSeries !== null ? selectDateTypeForWholeCurveTimeSeries?.label : "XAxis Period Type"}
                    </SelectValue>
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      {
                        DateWiseChartOptions && DateWiseChartOptions.length > 0 ? DateWiseChartOptions.map((item, index) => {
                          return <SelectItem key={index} className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2" value={JSON.stringify(item)}>{item?.label}</SelectItem>
                        }) : <SelectItem disabled className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2 text-center" value={'No option'}>{'No option'}</SelectItem>
                      }
                    </SelectGroup>
                  </SelectContent>
                </ShadCnSelect>
                {/* <Button className="px-5 py-[7px]" onClick={handleApplyChartDateType}>Apply</Button> */}
              </div>

            </div>

            <WholeCurveTimeSeriesChart
              chartData={withoutWholeTimeSeriesChartData}
              isLoading={dataLoad}
              ycrAssetData={ycrAssetData}
              selectDateType={selectDateTypeForWholeCurveTimeSeries} setSelectDateType={setSelectDateTypeForWholeCurveTimeSeries}
              actualPrepareAssetValueData={actualPrepareAssetValueData}
            />
          </CardContent>
        </Card>
      ) : (
        ""
      )}
    </div>
  );
};

export default CurvesContent;
